export default "<m4u-page [Page]=\"THIS\" [IsNoToolbar]=\"true\">\r\n\r\n</m4u-page>";